export default "__VITE_ASSET__CD6ALv8A__"